import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
import {
  Button,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
const TITLE = "Hijri to Gregorian Converter";
const DESCRIPTION = "Convert date from Hijri to Gregorian by entering the Hijri date and finding its equivalent in Gregorian using the electronic date converter.";
const KEYWORDS = "Hijri, Gregorian, Umm al-Qura, Month, Muharram, Safar, Rabi' al-Awwal, Rabi' al-Thani, Jumada al-Ula, Jumada al-Thani, Rajab, Sha'ban, Ramadan, Shawwal, Dhu al-Qi'dah, Dhu al-Hijjah, Convert date, Hijri to Gregorian, Gregorian to Hijri, Umm al-Qura calendar, Hijri calendar, Islamic calendar, Gregorian calendar, Hijri months, Prayer times";
const OG_URL = 'https://do-calculate.com/calculator/en/hijri_to_gregorian';
const hijriMonths = [
  "Muharram",
  "Safar",
  "Rabi' al-Awwal",
  "Rabi' al-Thani",
  "Jumada al-Ula",
  "Jumada al-Thani",
  "Rajab",
  "Sha'ban",
  "Ramadan",
  "Shawwal",
  "Dhu al-Qi'dah",
  "Dhu al-Hijjah",
];
function ConversionToGregorian() {
  const [hijriYear, setHijriYear] = useState("");
  const [hijriMonth, setHijriMonth] = useState(1);
  const [hijriDay, setHijriDay] = useState(1);
  const [gregorianDate, setGregorianDate] = useState("");
  const [showError, setShowError] = useState(false);
  const handleYearChange = (event) => {
    setHijriYear(event.target.value);
    setGregorianDate("");
  };
  const handleMonthChange = (event) => {
    setHijriMonth(event.target.value);
    setGregorianDate("");
  };
  const handleDayChange = (event) => {
    setHijriDay(event.target.value);
    setGregorianDate("");
  };
  const convertToGregorian = () => {
    const currentDate = moment().format("YYYY-MM-DD");
    const hijriDate = `${hijriYear}-${hijriMonth}-${hijriDay}`;
    const isValidDate = moment(hijriDate, "iYYYY-iM-iD", true).isValid();
    if (
      isValidDate &&
      moment(hijriDate, "iYYYY-iM-iD").isSameOrBefore(currentDate) &&
      moment(hijriDate).year() > 1357
    ) {
      const convertedDate = getGregorianDate(hijriDate);
      setGregorianDate(convertedDate);
      setShowError(false);
    } else {
      setGregorianDate("");
      setShowError(true);
    }
  };
  const getGregorianDate = (date) => {
    const gregorian = moment(date, "iYYYY-iM-iD").format("YYYY-M-D");
    return gregorian;
  };
  const renderMonthOptions = () => {
    return hijriMonths.map((month, index) => (
      <MenuItem key={index} value={index + 1}>
        {month}
      </MenuItem>
    ));
  };
  const renderDayOptions = () => {
    const days = Array.from({ length: 30 }, (_, i) => i + 1);
    return days.map((day) => (
      <MenuItem key={day} value={day}>
        {day}
      </MenuItem>
    ));
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <p> The Hijri to Gregorian date converter is a useful tool for converting dates between the Islamic Hijri calendar and the Gregorian calendar. The Hijri calendar is a lunar calendar used by Muslims worldwide to determine religious events and holidays, while the Gregorian calendar is the internationally recognized solar calendar used for civil purposes. This converter allows users to easily convert dates from one calendar system to another, facilitating better understanding and coordination of events across different cultural and religious contexts. Whether you need to convert a specific date for personal, religious, or professional reasons, this tool provides a quick and accurate solution.</p>
      </div>
      <MobileUnderCalAds />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  This online calculator provides an easy way to convert dates from the Hijri to the Gregorian calendar. Simply, the user selects the conversion direction and enters the desired Hijri date. Then, the calculator automatically performs the conversion and presents the converted date in the Gregorian calendar. The result is displayed in two formats: the first in a digital format, and the second by detailing the day, month, and year. This calculator allows users to quickly and accurately obtain converted dates between the Hijri and Gregorian calendars, making it easy to organize times and events in daily life.
                </p>
                <br />
                <p>
                  Through this calculator, you can enter the date in the Hijri format, and it will convert the entered date to its equivalent in the Arabic Gregorian calendar according to the Umm al-Qura calendar.
                </p>
              </div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <label
                  htmlFor="dateOfBirth"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  Enter the Hijri Date
                </label>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="form-group mt-3 mt-md-0">
                  <div className="row">
                    <div className="col">
                      <TextField
                        label="Year"
                        name="year"
                        value={hijriYear}
                        onChange={handleYearChange}
                        inputProps={{
                          required: true,
                        }}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <Select
                        value={hijriMonth}
                        onChange={handleMonthChange}
                        size="small"
                        color="success"
                        sx={{
                          width: "120px",
                          overflow: "hidden",
                          backgroundColor: "#f9f9f9",
                          fontSize: "14px",
                          padding: "2px 0",
                          ml: "10px",
                        }}
                      >
                        {renderMonthOptions()}
                      </Select>
                      <Select
                        value={hijriDay}
                        onChange={handleDayChange}
                        size="small"
                        color="success"
                        sx={{
                          width: "70px",
                          overflow: "hidden",
                          backgroundColor: "#f9f9f9",
                          fontSize: "14px",
                          padding: "2px 0",
                        }}
                      >
                        {renderDayOptions()}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col text-center">
                <br />
                <Button
                  variant="contained"
                  color="success"
                  onClick={convertToGregorian}
                  disabled={!showError}
                  sx={{
                    fontSize: {
                      md: "17px",
                    },
                    mt: "25px",
                    mb: "10px",
                  }}
                >
                  Calculate
                </Button>
              </div>
              <div className="row">
                {showError && (
                  <p style={{ color: "red" }}>
                    Please enter a date between 1358 AH and the current date.
                  </p>
                )}
                <div className="col">
                  {gregorianDate && !showError && (
                    <Fragment>
                      <hr style={{ margin: "0 0 1rem 0" }} />
                      <TableContainer
                        component={Paper}
                        style={{ marginBottom: "15px" }}
                      >
                        <Table style={{ marginBottom: "0" }}>
                          <TableHead>
                            <TableRow style={{ backgroundColor: "#4caf50" }}>
                              <TableCell
                                style={{
                                  color: "white",
                                  textAlign: "center",
                                  fontSize: "20px",
                                }}
                              >
                                Entered Date
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "white",
                                  textAlign: "center",
                                  fontSize: "20px",
                                }}
                              >
                                Equivalent Gregorian Date
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  fontSize: "18px",
                                }}
                              >
                                {`${hijriYear}-${hijriMonth}-${hijriDay}`}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  fontSize: "18px",
                                }}
                              >
                                {gregorianDate}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fragment>
                  )}
                </div>
              </div>
              <hr />
              <div className="row">
                <RelatedLinks />
                <br />
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.humanCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Convert Gregorian Date to Hijri</div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Convert Gregorian Date to Hijri Online</h2>{" "}
                </u>
                <br />
                <p>
                  Use the online calculator as an effective means to convert dates from the Gregorian to the Hijri calendar. You can easily convert birthdates or important event dates. Simply enter the Gregorian date you want to convert, and the application will automatically perform the conversion and provide the converted date in the Hijri calendar.
                  This conversion is useful in various scenarios, such as registering births in countries that use the Hijri calendar or organizing schedules in environments that use this time system.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Steps for Date Conversion</h2>
                </u>
                <br />
                <p>Use the date converter from Hijri to Gregorian easily. Select the conversion direction, choose the day, month, and year, and then convert it. The correct date is automatically determined according to the calendar you selected by changing the country or choosing the Umm al-Qura calendar.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Practical Application and Example of Date Conversion</h2>
                </u>
                <br />
                <p>
                  The application provides a practical example of converting the birth date of a person born in a foreign country on 15/9/2020. You can use the application to convert this date to the Hijri calendar to register the newborn in Saudi Arabia, for example. By entering the day 15, month 9, and year 2020 into the conversion system, the converted date will appear in various formats, such as 1442-01-28 or 28 Muharram 1442, completing the process successfully.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Benefits of Date Conversion</h2>
                </u>
                <br />
                <p>
                  This calculator offers many benefits, allowing you to use it to convert dates of your events or even official documents. Whether you are planning to travel or organizing your personal events, accurate date conversion meets your needs.
                </p>
              </div>
            </div>
          </div>
          <br />
        </div>
         </div>
</div>
  );
}
export default ConversionToGregorian;
